/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import qs from 'qs';

import styles from './index.module.less';
import { Bank } from '../components/bank';
import { Ewallet } from '../components/ewallet';
import { Mphone } from '../components/mphone';
import { Gate } from '../components/gate';
import { Voucher } from '../components/voucher';
import Footer from '../../components/footer';

import request from '../../utils/request';

export default class Home extends Component {
    state = {
        tabList: [
            {
                name: 'ewallet-tab',
                title: "E-Wallet",
                showed: false
            }, {
                name: 'bank-tab',
                title: "Bank",
                showed: false
            }, {
                name: 'mphone-tab',
                title: "Mobile",
                showed: false
            }, {
                name: 'voucher-tab',
                title: "Voucher",
                showed: false
            }, {
                name: 'gate-tab',
                title: "gate",
                showed: false
            }
        ],
        amount: 0,
        bankCode: '',
        payType: '',

        selectedTab: '',
        ewalletList: [],
        phoneList: [],
        voucherList: [],

    }

    bindTabItem = (name) => {
        if (name) {
            console.log(name)
            this.setState({ selectedTab: name })
        }
    }

    render() {
        const { tabList, selectedTab } = this.state;

        const renderContent = () => {
            switch (selectedTab) {
                case 'ewallet-tab': return <Ewallet />;
                case 'bank-tab': return <Bank />;
                case 'mphone-tab': return <Mphone />;
                case 'voucher-tab': return <Voucher />;
                case 'gate-tab': return <Gate />;
                default: return null;
            }
        }

        return <div>
            <div className={styles.container}>
                <div className={styles.head_info}>
                    <div className={styles.title_type}>
                        Thanh toán cho <span className={styles.from_type}></span>
                    </div>
                    <div className={styles.pay_total}><span className={styles.pay_money}>0</span>đ</div>
                </div>
                {/* 切换tab */}
                <div className={styles.tab_wrapper}>
                    <div className={styles.tab_list}>
                        <ul className={styles.tab}>
                            {tabList.map(item => (<li key={item.name} className={`${styles.tab_item} ${selectedTab === item.name ? styles.tab_active : ''}`} data-type={item.name} onClick={this.bindTabItem.bind(null, item.name)}>{item.title}</li>))}
                        </ul>
                    </div>
                    {/* tab内容体 */}
                    {renderContent()}
                    <Footer />
                </div>
            </div>
        </div >
    }
}